<div class="modal-header">
  <h4 class="modal-title">{{'CHANGE_PASSWORD_TITLE_SETUP_NEW_PASSWORD' | translate}}</h4>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="updatePassword()">
    <!-- Old password -->
    <div class="mb-3">
      <label class="form-label">
        {{'CHANGE_PASSWORD_LABEL_PASSWORD' | translate}}<span class="text-danger">*</span>
      </label>
      <input formControlName="password" type="password" class="form-control" />
      <div *ngIf="hasError('password', 'required')" class="text-danger small">
        {{'CHANGE_PASSWORD_VALIDATE_REQUIRED_PASSWORD' | translate}}
      </div>
      <div *ngIf="hasError('password', 'minlength')" class="text-danger small">
        {{'CHANGE_PASSWORD_VALIDATE_MIN_PASSWORD' | translate}}
      </div>
      <div class="text-danger small" *ngIf="isFieldInvalid('currentPassword')">
        {{ getFieldError('currentPassword') | translate }}
      </div>
    </div>

    <!-- New password -->
    <div class="mb-3">
      <label class="form-label">
        {{'CHANGE_PASSWORD_LABEL_NEW_PASSWORD' | translate}} <span class="text-danger">*</span>
      </label>
      <input formControlName="newPassword" type="password" class="form-control" placeholder="••••••••" />
      <app-password-strength-bar [password]="newPassword"></app-password-strength-bar>

      <div *ngIf="hasError('newPassword', 'required')" class="text-danger small">
        {{'CHANGE_PASSWORD_VALIDATE_REQUIRED_NEW_PASSWORD' | translate}}
      </div>
      <div *ngIf="hasError('newPassword', 'minlength')" class="text-danger small">
        {{ 'CHANGE_PASSWORD.VALIDATION.MIN' | translate:{ min: 8 } }}
      </div>
      <div *ngIf="hasError('newPassword', 'sameAsOldPassword')" class="text-danger small">
        {{'CHANGE_PASSWORD_VALIDATE_NOT_SAME_OLD' | translate}}
      </div>
      <div class="text-danger small" *ngIf="isFieldInvalid('newPassword')">
        {{ getFieldError('newPassword') | translate }}
      </div>
    </div>

    <!-- Confirm password -->
    <div class="mb-3">
      <label class="form-label">
        {{'CHANGE_PASSWORD_LABEL_CONFIRM_NEW_PASSWORD' | translate}} <span class="text-danger">*</span>
      </label>
      <input formControlName="confirmPassword" type="password" class="form-control" placeholder="••••••••" />
      <div *ngIf="hasError('confirmPassword', 'required')" class="text-danger small">
        {{'CHANGE_PASSWORD_VALIDATE_REQUIRED_CONFIRM_PASSWORD' | translate}}
      </div>
      <div *ngIf="hasError('confirmPassword', 'passwordMismatch')" class="text-danger small">
        {{'CHANGE_PASSWORD_VALIDATE_NOT_MATCH_CONFIRM_PASSWORD' | translate}}
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">{{'BUTTON.CLOSE' | translate}}</button>
  <app-loading-button label="BUTTON.UPDATE" btnClass="btn-primary w-20" [loading]="isLoading"
    (clicked)="updatePassword()"></app-loading-button>
</div>
